<template>
	<div class="home">
		<div class="welcome" ref="welcome">
			<h1>Kia Ora,</h1>
			<div><b>Haere</b> is the Maori name for depart, travel.</div>
			<div>It's also a letter away from "here".</div>
			<br>
			<div>For the last few years this has been my lifestyle:</div>
			<div>settle for a while somewhere and when I feel like time</div>
			<div>has come, take a couple of months or a few years off </div>
			<div>before moving to a new mysterious destination…</div>
			<br>
			<div>This website contain some of the treasures I had</div>
			<div>the chance to meet during my years-long journey.</div>
		</div>
	</div>
</template>

<script>
// animation
import anime from 'animejs'

export default {
	name: 'home',
	methods: {
		onSectionLeave (el, done) {
			this.$bus.$emit('transitioner:show', done)
		},
		introAnimation () {
			anime({
				targets: [this.$refs.welcome.children],
				opacity: 1,
				translateY: [60, 0],
				easing: 'easeOutExpo',
				duration: 1500,
				delay: function (el, i) { return i * 50 }
			})
		}
	},
	mounted () {
		this.$bus.$once('section:ready', this.introAnimation.bind(this))
	}
}
</script>

<style>
.welcome{
	font-family: 'Merriweather';
	position: absolute;
	left: 6rem;
	bottom: 15vh;
	width: 30%;
	text-align: left;
}
.welcome h1{
	opacity: 0;
	transform: translateY(20px);
}
.welcome div{
	opacity: 0;
	transform: translateY(20px);
}
</style>



// WEBPACK FOOTER //
// src/sections/Home.vue